<form (ngSubmit)="save()" [formGroup]="ruleForm">
	<div [alarisLoading]="rulesService.loading$">
		<div class="edit-panel-header">
			<alaris-icon name="icon-add-contact"></alaris-icon>
			{{ rule.ruleId ? ("rules.edit" | translate) : ("rules.create" | translate) }}
		</div>
		<div [alarisFade]="'vertical'" class="form-group panel-content">
			<alaris-input formControlName="name" [errors]="errors">
				{{ "rules.name" | translate }}
			</alaris-input>

			<alaris-text-area
				[expandable]="true"
				[placeholder]="'gl.textAreaHint' | translate"
				formControlName="prefixList"
				#prefixListArea
				maxHeight="none"
				mode="tag"
				[errors]="errors"
			>
				{{ "rules.prefix_list" | translate }}
			</alaris-text-area>

			<alaris-text-area
				[expandable]="true"
				[placeholder]="'gl.textAreaHint' | translate"
				formControlName="senderList"
				maxHeight="none"
				mode="tag"
				[tagSeparators]="[]"
			>
				{{ "rules.sender_list" | translate }}
				<ng-template #tagsContainer alarisTextAreaTagsContainerCtx let-tf>
					@let notRegexpSenders = getNotRegexp(tf.displayedTags);
					<div class="tags-sender">
						@for (tag of notRegexpSenders; track tag.originalIndex) {
							<alaris-tag
								[alarisTaggableFieldItem]="tf"
								[index]="tag.originalIndex"
								[fill]="true"
								class="tag-sender"
								tabindex="0"
							>
								<span class="text">{{ tf.getText(tag.value) }}</span>
								@if (tf.isTagDeletable) {
									<alaris-icon
										(click)="tf.onRemoveIconClickHandler(tag.originalIndex)"
										name="icon-close"
										class="remove-icon"
									></alaris-icon>
								}
							</alaris-tag>
						}
					</div>
					@let regexpSenders = getRegexp(tf.displayedTags);
					<div class="tags-sender">
						@for (tag of regexpSenders; track tag.originalIndex) {
							<alaris-tag
								[alarisTaggableFieldItem]="tf"
								[index]="tag.originalIndex"
								[fill]="true"
								class="tag-sender regexpSender"
								tabindex="0"
							>
								<span class="text">{{ tf.getText(tag.value) }}</span>
								@if (tf.isTagDeletable) {
									<alaris-icon
										(click)="tf.onRemoveIconClickHandler(tag.originalIndex)"
										name="icon-close"
										class="remove-icon"
									></alaris-icon>
								}
							</alaris-tag>
						}
					</div>
				</ng-template>
			</alaris-text-area>
			<alaris-toggle [formControl]="inclusiveList">{{ "rules.include_products" | translate }}</alaris-toggle>
			@if (inclusiveList.value) {
				@if (!eapiEnable) {
					<alaris-input formControlName="productList" [errors]="errors">
						{{ "rules.product_list" | translate }}
					</alaris-input>
				} @else {
					<alaris-multi-select2
						[expandable]="true"
						[label]="'rules.product_list' | translate"
						[optionsCount]="products.length"
						[displayWith]="displayProduct.bind(this)"
						(click)="OnChange()"
						[showAllSelected]="true"
						[separator]="separator"
						formControlName="productList"
						mode="tag"
						[errors]="errors"
					>
						<alaris-select-filter2 [formControl]="productsFilter"></alaris-select-filter2>
						@for (product of products; track product) {
							@if (product.is_active) {
								<alaris-multi-options2 [value]="product.product_id.toString()">
									{{ getProductFullName(product) }}
								</alaris-multi-options2>
							}
						}
					</alaris-multi-select2>
				}
			}
			@if (!eapiEnable) {
				<alaris-input formControlName="productsNames" [errors]="errors">
					{{ "rules.product_names" | translate }}
				</alaris-input>
			} @else {
				<alaris-select2
					[label]="'rules.product_type' | translate"
					formControlName="productsType"
					[errors]="errors"
				>
					@for (type of productNamesTypes; track type) {
						<alaris-options2 [value]="type">
							{{ type }}
						</alaris-options2>
					}
				</alaris-select2>

				<alaris-multi-select2
					[alarisLoading]="productsService.loading$"
					[backdrop]="false"
					[expandable]="true"
					[label]="'rules.product_names' | translate"
					[optionsCount]="productsNames.length"
					[showAllSelected]="true"
					formControlName="productsNames"
					mode="tag"
					[errors]="errors"
				>
					<alaris-select-filter2 [formControl]="productsNamesFilter"></alaris-select-filter2>
					@for (name of productsNames; track name) {
						<alaris-multi-options2 [value]="name">{{ name }}</alaris-multi-options2>
					}
				</alaris-multi-select2>
			}
			<alaris-card
				formArrayName="choiceList"
				size="auto"
				class="choices"
				(cdkDropListDropped)="drop($event)"
				cdkDropList
			>
				@let choiceListControls = ruleForm.controls["choiceList"];
				@for (choice of choiceListControls.controls; track choice; let i = $index) {
					<alaris-card size="auto" class="choice">
						<div class="choice-header">
							<div>{{ "rules.choice" | translate }} #{{ i + 1 }}</div>
							<div class="choice-delete" (click)="removeChoice(i)">
								{{ "gl.delete" | translate }}
							</div>
						</div>
						<form formGroupName="{{ i }}">
							<form formArrayName="sources">
								@let sourcesControls = getSources(i);
								@for (shareGroup of sourcesControls?.controls; track shareGroup; let j = $index) {
									<form formGroupName="{{ j }}">
										<div class="choice-items">
											@if (getEnableLCR(i) === "No") {
												<alaris-select2
													[displayWith]="displayChoice.bind(this)"
													[label]="'rules.source' | translate"
													formControlName="Source"
													[errors]="errors"
												>
													<alaris-select-filter2
														[formControl]="sourcesFilter"
													></alaris-select-filter2>
													@for (source of getAvailableSources(i); track source) {
														<alaris-options2 [value]="source.Name">
															{{ source.Name }}
														</alaris-options2>
													}
												</alaris-select2>
											}
											@if (getEnableLCR(i) === "No") {
												@if (getSharesValue(i) > 1) {
													<alaris-input-number
														formControlName="Share"
														suffix=" %"
														[label]="'rules.share' | translate"
														[errors]="errors"
													>
													</alaris-input-number>
												}
											}
											@if (getEnableLCR(i) === "Yes") {
												<alaris-multi-select2
													[alarisLoading]="sourcesService.loading$"
													[backdrop]="false"
													[displayWith]="displayChoices.bind(this)"
													[expandable]="true"
													[label]="'rules.source' | translate"
													[optionsCount]="sources.length"
													[showAllSelected]="true"
													[separator]="separator"
													formControlName="Source"
													mode="tag"
													[errors]="errors"
												>
													<alaris-select-filter2
														[formControl]="sourcesFilter"
													></alaris-select-filter2>
													@for (source of getAvailableSources(i); track source) {
														<alaris-multi-options2 [value]="source.Name">
															{{ source.Name }}
														</alaris-multi-options2>
													}
												</alaris-multi-select2>
											}
											@if (getEnableLCR(i) === "No") {
												<div class="icon-center" (click)="removeSource(i, j)">
													<alaris-icon name="icon-delete"></alaris-icon>
												</div>
											}
										</div>
									</form>
								}
								@if (getEnableLCR(i) === "No") {
									<button
										(click)="addSource(i)"
										alaris-button
										bType="outline"
										size="lg"
										type="button"
									>
										<alaris-icon name="icon-plus"></alaris-icon>
										{{ "rules.add_source" | translate }}
									</button>
								}
							</form>
							<alaris-select2
								class="choice-items"
								[label]="'rules.enable_LCR' | translate"
								formControlName="enableLCR"
								[errors]="errors"
							>
								@for (v of LCRVariants; track v) {
									<alaris-options2 [value]="v" (click)="OnChangeEnableLCR(i)">
										{{ v }}
									</alaris-options2>
								}
							</alaris-select2>
						</form>
					</alaris-card>
				}
			</alaris-card>
			<button (click)="addChoice()" alaris-button bType="outline" size="lg" type="button">
				<alaris-icon name="icon-plus"></alaris-icon>
				{{ "rules.add_choice" | translate }}
			</button>
			<button (click)="reset()" alaris-button bType="secondary" class="reset-button" size="lg" type="button">
				<alaris-icon name="icon-refresh-clock-wise"></alaris-icon>
				{{ "gl.reset" | translate }}
			</button>
		</div>
		<div class="edit-panel-footer">
			<button
				[disabled]="ruleForm.invalid || (!ruleForm.dirty && !inclusiveList.dirty)"
				alaris-button
				bType="primary"
				size="lg"
				type="submit"
			>
				<alaris-icon class="in-primary" name="icon-success"></alaris-icon>
				{{ "gl.submit" | translate }}
			</button>
			<button (click)="close()" alaris-button bType="outline" size="lg" type="button">
				{{ "actions.close" | translate }}
			</button>
		</div>
	</div>
</form>
